import { ACCOUNT_TYPES } from "../../app/appConstants.js";
import { NewLifeAccountButtonStyled } from "./styled/NewLifeAccountButtonStyled.js";
import { BinIcon } from "../../components/icon/Icon.jsx";
import classNames from "classnames";
import { useMemo } from "react";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

function NewLifeAccountButton(props) {
    const {getLangPath} = useLangContext();
    const {
        account,
        active,
        onClickHandler,
    } = props;

    const icon = useMemo(() => {
        return account.type === ACCOUNT_TYPES.DEMO ? 'IcEducation' : 'IcCoinStack';
    }, [account]);

    return <NewLifeAccountButtonStyled onClick={onClickHandler}
                                       className={classNames({
                                           'active': active,
                                           'respawned': !!account.respawned,
                                       })}
    ><BinIcon
            name={icon}/> {getLangPath(`bonus.new_life.account_${account.type === ACCOUNT_TYPES.DEMO ? 'demo' : 'real'}`)}{account.respawned ?
            <div className="refilled">{getLangPath('bonus.new_life.badge_refilled')}</div> : ''}
    </NewLifeAccountButtonStyled>
}

export default NewLifeAccountButton;
